<template>
	<div class="board">
		<img class="bottom-logo" src="./images/logo-with-name.png">
		<v-row no-gutters>
			<v-col cols="12">
				<v-row>
					<v-col md="4" class="align-self-center fast-play-header left-header">
						<span>
						<v-img  max-height="120" contain class="m-t-negative top-logo" src="./images/logo-black.png"></v-img>
						</span>
					</v-col>
					<v-col md="4" class="fast-play-header">
						<v-row class="pick-numbers" no-gutters>
							<v-col class="text-center picks"> PICKS </v-col>
							<v-col class="text-center picks"> NUMBERS </v-col>
						</v-row>
					</v-col>
					<v-col
						md="4"
						class="text-center align-self-center card-header fast-play-header right-header"
					>
						PAYOUTS
					</v-col>
				</v-row>
				<v-row align="stretch">
					<v-col
						cols="4"
						class="d-flex flex-column gray-background left-footer"
					>
						<br>
						<upcoming-sortition
							id="upcoming-result"
							:upcoming-sortition="upcomingSortition"
							@refresh="fetchUpcomingSortition"
						></upcoming-sortition>
						<div class="card-header"><span>Winning Numbers</span></div>
						<result-display
							v-for="result in results.entries.slice(0, 1)"
							:key="result.sortition.id"
							:result="result"
							:white="true"
						>
						</result-display>
					</v-col>
					<v-col
						cols="4"
						class="d-flex flex-column white-background"
						v-if="results.entries.slice(1).length > 0"
					>
						<result-display
							v-for="result in results.entries.slice(1)"
							:key="result.sortition.id"
							:result="result"
						>
						</result-display>
					</v-col>
					<v-col
						cols="4"
						class="d-flex flex-column right-footer gray-background"
					>
						<!-- Playouts card -->
						<prizes-card v-if="showPrizes" :prizes="prizes"></prizes-card>
						<results-card
							v-if="showResults"
							:results-by-lottery="resultsToShow"
							display-horizontally
							light
						></results-card>
					</v-col>
				</v-row>
			</v-col>
			<v-col id="page-url" cols="12" class="text-center py-0">
				<span>Visit our page {{ url }}</span>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ResultDisplay from './ResultDisplay.vue';
import UpcomingSortition from './UpcomingSortition.vue';
import BaseBoard from '../BaseBoard.js';
import PrizesCard from './PrizesCard.vue';
import ResultsCard from '../../common/ResultsCard';

export default {
	name: 'Board',
	extends: BaseBoard,
	components: {
		ResultsCard,
		UpcomingSortition,
		ResultDisplay,
		PrizesCard
	}
};
</script>

<style
	scoped
	lang="scss">
@import 'css/variables';
/*@import "css/main";*/
.bottom-logo {
	position: absolute;
	bottom: 50px;
	left: -8px;
	max-height: 160px;
}

.fast-play-header {
	height: 55px;
	background-color: $red;
	color: white !important;
}

.right-header {
	border-top-right-radius: 20px;
}

.left-header {
	border-top-left-radius: 20px;
}

.right-footer {
	border-bottom-right-radius: 20px;
}

.left-footer {
	border-bottom-left-radius: 20px;
}

.pick-numbers {
	font-size: 1.7rem;
	color: white;
}

.picks {
	padding-top: 0;
}

.result-display {
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}
}

.v-card {
	color: white;
	border-radius: 30px;

	&:not(#primary-card) {
		box-shadow: 8px 6px 20px 0 #07000080;
	}
}

::v-deep .v-card #countdown {
	line-height: 50px;
	text-align: center;
	font-family: 'RobotoBlack', serif;
}


#upcoming-sortition {
	margin-top: 9px;
	margin-bottom: 9px;
}

.card-header {
	color: white;
	font-size: 1.5rem;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
}

#page-url span {
	font-size: 1.3rem;
	color: white;
}

.gray-background {
	background-color: $black;
}

.white-background {
	background-color: white;
}

.board {
	max-width: 90vw;
	margin-right: auto;
	margin-left: auto;
}
	.m-t-negative {
		margin-top: -30px;
	}
</style>
